// extracted by mini-css-extract-plugin
module.exports = {"skillContainer":"Container_skillContainer__36X1g","heading":"Container_heading__3kBiP","years":"Container_years__3t26V"};